"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _HelpRounded = _interopRequireDefault(require("@mui/icons-material/HelpRounded"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ErrorBox = _ref => {
  let {
    type,
    text,
    title
  } = _ref;
  const getColor = () => {
    switch (type) {
      case _constants.errorType.info:
        return _constants.colors['main-color-cl-30'];
      case _constants.errorType.warning:
        return _constants.colors['main-color-cl-22'];
      case _constants.errorType.critical:
        return _constants.colors['main-color-cl-94'];
      default:
        return _constants.colors['main-color-cl-30'];
    }
  };
  const color = getColor();
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    sx: {
      display: 'flex',
      alignItem: 'center',
      justifyContent: 'start',
      marginBottom: 5,
      borderRadius: _constants.borderRadius.card,
      border: '2px solid',
      backgroundColor: _constants.colors['main-color-cl-92'],
      boxShadow: _constants.boxShadow.primary,
      height: 'auto',
      width: 'fit-content',
      padding: '16px 64px 16px 16px',
      borderColor: color
    }
  }, /*#__PURE__*/_react.default.createElement(_HelpRounded.default, {
    sx: {
      width: '30px',
      height: '30px',
      margin: '0 20px 0 5px',
      alignSelf: 'flex-start',
      color
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      fontWeight: 'bold',
      color: _constants.colors['main-color-cl-01']
    },
    component: "h6",
    variant: "h6"
  }, title), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      color: _constants.colors['main-color-cl-01']
    },
    component: "span",
    variant: "subtitle1"
  }, text)));
};
exports.ErrorBox = ErrorBox;
ErrorBox.propTypes = {
  type: _propTypes.default.oneOf([_constants.errorType.info, _constants.errorType.warning, _constants.errorType.critical]).isRequired,
  text: _propTypes.default.string,
  title: _propTypes.default.string
};